import React, { useContext, useEffect } from "react";
import { LoadingContext } from "./Admin";

// A component wrapper to handle page transitions smoothly without showing a loader
const PageTransition = ({ children, immediate = false }) => {
    const { setIsPageTransition } = useContext(LoadingContext);

    useEffect(() => {
        // Set page transition state to false immediately or after a tiny delay
        // to allow smooth transitions without displaying a loader
        if (immediate) {
            setIsPageTransition(false);
        } else {
            // Very short timeout to prevent flashing of loading states
            const timer = setTimeout(() => {
                setIsPageTransition(false);
            }, 50);
            
            return () => clearTimeout(timer);
        }
    }, [setIsPageTransition, immediate]);

    return <>{children}</>;
};

export default PageTransition; 